// extracted by mini-css-extract-plugin
export default {"users-list-main":"ContentBody_users-list-main__dgOb6"};